import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { Image, Popup, Segment } from 'semantic-ui-react'

import close from '../../../assets/images/close-fuchsia.png'

class Bubble extends Component {
    constructor (props) {
        super(props)
        this.state = {
            isOpen: this.props.open || false
        }
        autoBind(this)
    }

    toggle () {
        this.setState({ isOpen: !this.state.isOpen })
    }

    render () {
        return (
            <Popup
                className='bubble'
                on='click'
                open={this.state.isOpen}
                onOpen={() => { this.setState({ isOpen: true }) }}
                position={this.props.position}
                trigger={
                    <Image
                        className={`bubble-trigger ${this.props.name}`}
                        src={this.state.isOpen ? this.props.openImage : this.props.closedImage}
                        onClick={() => { this.toggle() }}
                    />
                }
                content={
                    <Segment className='bubble-content'>
                        <Segment className='bubble-header' clearing>
                            <Segment className='bubble-title' floated='left'>{this.props.title}</Segment>
                            <Segment className='bubble-close' floated='right'>
                                <Image src={close} onClick={() => { this.toggle() }}/>
                            </Segment>
                        </Segment>
                        <Segment className='bubble-body'>{this.props.text}</Segment>
                    </Segment>
                }
            />
        )
    }
}

export default Bubble



// WEBPACK FOOTER //
// ./src/components/common/bubble/index.js